import { render } from "./KtbView.vue?vue&type=template&id=472aa02f&scoped=true"
import script from "./KtbView.vue?vue&type=script&lang=js"
export * from "./KtbView.vue?vue&type=script&lang=js"

import "./KtbView.vue?vue&type=style&index=0&id=472aa02f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472aa02f"]])

export default __exports__